import { render, staticRenderFns } from "./NotesOnContactPage.vue?vue&type=template&id=57a9d56c&"
import script from "./NotesOnContactPage.vue?vue&type=script&lang=js&"
export * from "./NotesOnContactPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports